import { render, staticRenderFns } from "./formSysUserPerm.vue?vue&type=template&id=7d78ec58&"
import script from "./formSysUserPerm.vue?vue&type=script&lang=js&"
export * from "./formSysUserPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports